import { Routes, RouterModule } from '@angular/router';

const externalUsersManagementRoutes: Routes = [
];

export const ExternalUsersManagementRouter = RouterModule.forChild(externalUsersManagementRoutes);